// Enum with values
export enum PowerIssue {
	Outage = 'Outage',
	PartialOutage = 'Partial power',

	DimOrBrightLights = 'Bright or dim lights',

	// Subcategories under bright or dim
	LightGoingBrightToDim = 'Lights going bright to dim',
	ConstantDim = 'Lights constantly dim',
	ConstantBright = 'Lights constantly bright',

	FlickeringLights = 'Flickering Lights',
}
